import { ForgotPasswordModal } from './ForgotPasswordModal'
import { ForgotPasswordSuccessModal } from './ForgotPasswordSuccessModal'
import { SignInModal } from './SignInModal'
import { SignUpModal } from './SignUpModal'
import { SponsorModal } from './SponsorModal'
import { WelcomeModal } from './WelcomeModal'

export const AuthModals = () => (
  <>
    <SignInModal />
    <SignUpModal />
    <ForgotPasswordModal />
    <WelcomeModal />
    <ForgotPasswordSuccessModal />
    <SponsorModal />
  </>
)
